module.exports = __webpack_public_path__ + "img/img22.469881c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img22.png
// module id = 263
// module chunks = 0